import type { GetDownloadUrlApiArg } from '~/api/k2/typedefs.autogen';
import type { ServiceRequestConfig } from '~/services/createService';

import {
  downloadDocument,
  type DownloadDocumentMode,
} from './downloadDocument';

export type DownloadTicketDocumentArg = GetDownloadUrlApiArg & {
  mode?: DownloadDocumentMode;
  fileFormat?: string | null;
  targetFormat?: 'pdf';
};

export const downloadTicketDocument = (
  request: DownloadTicketDocumentArg,
  options?: ServiceRequestConfig,
): Promise<File> =>
  downloadDocument(`/tickets/${request.ticketId}`, request, options);
